export default "__VITE_ASSET__D630aoOI__"